import { postEvent } from '@common/utils/fetcher';

import { useAuthStore } from '@entities/auth/stores/useAuthStore';

/**
 * The paywall events the feed sends when a swipe hits the daily limit
 * (ProfilesList showSwipeLimit): a skip or a recommendation spends the same
 * swipes. Nothing was taken from the count locally, so the swipes used are
 * the limit less what the store still holds.
 */
export const reportSwipeLimitPaywall = () => {
  const { limit, remaining } = useAuthStore.getState().swipe_status ?? {};
  const usedSwipes =
    typeof limit === 'number' && typeof remaining === 'number'
      ? limit - remaining
      : null;
  const metadata = {
    source: 'swipe_limit_reached',
    swipes_until_paywall: usedSwipes,
    minutes_since_registration: null,
  };

  void postEvent('first_paywall_impression', metadata, true);
  void postEvent('paywall_cycle_hit', metadata);
};
